import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./year-header.style";
import LeftArrowIcon from "@iconify/icons-mdi/arrow-left";
import { InlineIcon } from "@iconify/react";

interface MyLeaveYearHeaderProps {
  handleIconClick: () => void;
  children: React.ReactNode;
}

export const MyLeaveYearHeader: React.FC<MyLeaveYearHeaderProps> = ({
  handleIconClick,
  children,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.root}>
      <Box className={classes.sideContainer}>
        <Box className={classes.iconContainer} onClick={handleIconClick}>
          <InlineIcon
            id="my-leaves-year-header-button"
            className={classes.icon}
            icon={LeftArrowIcon}
          />
        </Box>
      </Box>
      <Box>
        <Typography variant="h2" color={theme.palette.white.main}>
          {children}
        </Typography>
      </Box>
      <Box className={classes.sideContainer} />
    </Box>
  );
};

export default MyLeaveYearHeader;
